import { redBankConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function RedBankPage() {
  return <CityPageTemplate config={redBankConfig} />;
}